export const isImageFileName = (fileName: string) => {
  const imageExtensions = /\.(jpeg|jpg|png)$/i;

  return imageExtensions.test(fileName);
}
